var _rect, _ellipse, _g, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _g2, _ellipse6, _ellipse7, _ellipse8, _ellipse9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburgerMenuBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 812,
    viewBox: "0 0 375 812",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1218_79235",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -73,
    y: 0,
    width: 522,
    height: 812
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -73,
    width: 522,
    height: 812,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1218_79235)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1218_79235",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: -333,
    width: 543,
    height: 549
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 459.633,
    cy: -58.5577,
    rx: 270.667,
    ry: 273.269,
    fill: "#F54F5E",
    stroke: "#F54F5E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1218_79235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.399 -514.406L911.733 32.1324",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.564 -507.505L904.898 39.0338",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.729 -500.604L898.063 45.9349",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.894 -493.703L891.227 52.8358",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.059 -486.802L884.392 59.7369",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.224 -479.9L877.557 66.6383",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.387 -473L870.72 73.5389",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.553 -466.098L863.886 80.4403",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.718 -459.197L857.051 87.3412",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.881 -452.296L850.214 94.2425",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.046 -445.395L843.379 101.144",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.212 -438.494L836.545 108.045",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.375 -431.593L829.708 114.946",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.54 -424.691L822.873 121.847",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.705 -417.791L816.038 128.748",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.868 -410.889L809.202 135.649",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.034 -403.988L802.368 142.55",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.199 -397.087L795.533 149.451",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.362 -390.186L788.696 156.352",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.527 -383.285L781.861 163.253",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.693 -376.384L775.027 170.154",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.856 -369.483L768.19 177.056",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.021 -362.582L761.355 183.956",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.187 -355.681L754.52 190.858",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.35 -348.78L747.683 197.759",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.516 -341.879L740.849 204.66",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.681 -334.978L734.014 211.561",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.846 -328.076L727.179 218.462",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.009 -321.176L720.342 225.363",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.175 -314.274L713.508 232.265",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.34 -307.373L706.673 239.165",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.503 -300.472L699.836 246.066",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.668 -293.571L693.001 252.968",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.834 -286.669L686.167 259.869",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.997 -279.769L679.33 266.77",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.162 -272.868L672.495 273.671",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.327 -265.967L665.661 280.572",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.49 -259.065L658.824 287.473",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.656 -252.164L651.99 294.374",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.821 -245.264L645.155 301.275",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9844 -238.362L638.318 308.176",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1494 -231.461L631.483 315.077",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3154 -224.56L624.649 321.978",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4785 -217.659L617.812 328.879",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6436 -210.758L610.977 335.781",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8086 -203.857L604.142 342.681",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9717 -196.956L597.305 349.583",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1377 -190.055L590.471 356.484",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3027 -183.154L583.636 363.385",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4658 -176.252L576.799 370.286",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6309 -169.352L569.964 377.187",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7969 -162.45L563.13 384.088",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.96 -155.549L556.293 390.989",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 -148.648L549.458 397.89",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29004 -141.747L542.623 404.792",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.54395 -134.846L535.789 411.693",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.3809 -127.945L528.953 418.594",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.2158 -121.044L522.118 425.495",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26.0508 -114.143L515.283 432.396",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32.8877 -107.241L508.446 439.297",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39.7217 -100.34L501.612 446.198",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-46.5566 -93.4395L494.777 453.099",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53.3936 -86.5383L487.94 460",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-60.2285 -79.637L481.105 466.901",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-67.0625 -72.7358L474.271 473.803",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-73.8994 -65.835L467.434 480.703",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80.7344 -58.9338L460.599 487.605",
    stroke: "#F54F5E"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -47.8665,
    rx: 125.667,
    ry: 126.875,
    fill: "#196DB6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.166,
    cy: 58.5577,
    rx: 29,
    ry: 29.2788,
    fill: "#26B6E0"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -34.3333,
    cy: 745.635,
    rx: 96.6667,
    ry: 97.5962,
    fill: "#26B6E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1218_79235",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -441,
    y: 643,
    width: 698,
    height: 705
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -92.333,
    cy: 995.481,
    rx: 348,
    ry: 351.346,
    fill: "#26B6E0",
    stroke: "#26B6E0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1218_79235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-95.0605 295.716L600.939 998.409",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101.897 302.618L594.103 1005.31",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-108.731 309.519L587.269 1012.21",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-115.566 316.42L580.434 1019.11",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-122.403 323.321L573.597 1026.01",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-129.238 330.222L566.762 1032.91",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-136.073 337.123L559.927 1039.82",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-142.909 344.024L553.091 1046.72",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149.744 350.925L546.256 1053.62",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-156.58 357.826L539.42 1060.52",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-163.415 364.727L532.585 1067.42",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-170.25 371.628L525.75 1074.32",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-177.086 378.529L518.914 1081.22",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-183.921 385.431L512.079 1088.12",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-190.757 392.332L505.243 1095.02",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-197.592 399.232L498.408 1101.92",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-204.427 406.134L491.573 1108.83",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-211.263 413.035L484.737 1115.73",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-218.098 419.936L477.902 1122.63",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.934 426.837L471.066 1129.53",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-231.769 433.738L464.231 1136.43",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-238.604 440.639L457.396 1143.33",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245.439 447.541L450.561 1150.23",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-252.275 454.441L443.725 1157.13",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-259.109 461.343L436.891 1164.04",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-265.945 468.244L430.055 1170.94",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-272.781 475.145L423.219 1177.84",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-279.616 482.046L416.384 1184.74",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-286.452 488.947L409.548 1191.64",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293.287 495.848L402.713 1198.54",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-300.122 502.749L395.878 1205.44",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-306.958 509.65L389.042 1212.34",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-313.794 516.551L382.206 1219.24",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-320.628 523.452L375.372 1226.14",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-327.464 530.354L368.536 1233.05",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-334.299 537.254L361.701 1239.95",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341.135 544.156L354.865 1246.85",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-347.97 551.057L348.03 1253.75",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-354.805 557.958L341.195 1260.65",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-361.641 564.859L334.359 1267.55",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-368.477 571.76L327.523 1274.45",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-375.312 578.661L320.688 1281.35",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-382.146 585.562L313.854 1288.25",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-388.982 592.463L307.018 1295.16",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-395.817 599.364L300.183 1302.06",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-402.653 606.266L293.347 1308.96",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-409.487 613.167L286.513 1315.86",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-416.323 620.067L279.677 1322.76",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-423.159 626.969L272.841 1329.66",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-429.994 633.87L266.006 1336.56",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-436.83 640.771L259.17 1343.46",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-443.665 647.672L252.335 1350.36",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-450.5 654.573L245.5 1357.27",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-457.336 661.474L238.664 1364.17",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-464.172 668.375L231.828 1371.07",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-471.006 675.276L224.994 1377.97",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477.842 682.177L218.158 1384.87",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-484.678 689.079L211.322 1391.77",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-491.513 695.979L204.487 1398.67",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-498.349 702.881L197.651 1405.57",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-505.183 709.782L190.817 1412.47",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-512.019 716.683L183.981 1419.37",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-518.854 723.584L177.146 1426.28",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525.689 730.485L170.311 1433.18",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-532.524 737.386L163.476 1440.08",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-539.36 744.287L156.64 1446.98",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-546.195 751.188L149.805 1453.88",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-553.031 758.09L142.969 1460.78",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-559.866 764.991L136.134 1467.68",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-566.701 771.891L129.299 1474.58",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-573.537 778.793L122.463 1481.49",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-580.372 785.694L115.628 1488.39",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-587.208 792.595L108.792 1495.29",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-594.043 799.496L101.957 1502.19",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-600.878 806.397L95.1221 1509.09",
    stroke: "#26B6E0"
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 459.633,
    cy: 771.01,
    rx: 125.667,
    ry: 126.875,
    fill: "#196DB6"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.5006,
    cy: 136.635,
    rx: 9.66667,
    ry: 9.75962,
    fill: "#F54F5E"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 332.999,
    cy: 741.731,
    rx: 19.3333,
    ry: 19.5192,
    fill: "#F54F5E"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 410.334,
    cy: 147.37,
    rx: 58,
    ry: 58.5577,
    fill: "#196DB6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenuBackground);
export default __webpack_public_path__ + "static/media/hamburger_menu_background.c909408da2d8ecab4db5aa297843c858.svg";
export { ForwardRef as ReactComponent };